// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"a75bb343","166":"311d941f"}[chunkId] + ".chunk.js";
};